/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import PathBrowserify from 'path-browserify';

import FileSystemPath from '../../../../core/file/system/file-system-path';

/**
 * @import { FileSystemDirectory as IFileSystemDirectory, FileSystemEntry } from '../../../../core/file/system'
 * @import FileSystemManager from './file-system-manager';
 */

/**
 * Složka v souborovém systému.
 * @implements {IFileSystemDirectory}
 */
export default class FileSystemDirectory {
  /**
   * Vytvoří instanci.
   * @param {FileSystemDirectoryHandle} directoryHandle
   * @param {FileSystemManager} fileSystemManager
   * @param {FileSystemPath} path Cesta ke složce.
   */
  constructor(directoryHandle, fileSystemManager, path) {
    this.directoryHandle = directoryHandle;
    this.fileSystemManager = fileSystemManager;
    this.path = path;
  }

  /** @type {IFileSystemDirectory['getName']} */
  getName() {
    return this.path.getBase();
  }

  /** @type {IFileSystemDirectory['getPath']} */
  getPath() {
    return this.path;
  }

  /** @type {IFileSystemDirectory['isDirectory']} */
  isDirectory() {
    return true;
  }

  /** @type {IFileSystemDirectory['isFile']} */
  isFile() {
    return false;
  }

  /** @type {IFileSystemDirectory['list']} */
  async list() {
    /** @type {FileSystemEntry[]} */
    const entries = [];

    for await (const [name] of this.directoryHandle.entries()) {
      const entryPath = new FileSystemPath(
        PathBrowserify.join(this.path.getNormalized(), name)
      );
      entries.push(await this.fileSystemManager.getEntry(entryPath));
    }
    return entries;
  }

  /** @type {IFileSystemDirectory['move']} */
  async move(toPath) {
    // Webová platforma nestahuje zipy widgetů, které rozbalí do temp složky a by bylo nutné přesouvat.
    throw await new Error('Not implemented');
  }

  /** @type {IFileSystemDirectory['remove']} */
  async remove(opts) {
    if (!(await this.fileSystemManager.hasDirectory(this.path))) {
      return;
    }
    const parent = await this.fileSystemManager.getDirectParent(this.path);
    await parent.removeEntry(this.getName(), opts);
  }
}
